(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

require('../../../modules/modules');

require('../../../templates/templates');

jQuery(function ($) {
  $(document).ready(function () {
    $('a').has('*').addClass('no-bottom-border');
  });
  // $(window).on('load', function() {
  //   resizeEdgeBG()
  //   $('.loading-spinner').hide()
  // })
  // $(window).resize(resizeEdgeBG)
});

// function resizeEdgeBG() {
//   jQuery(function($) {
//     if ($('.edge-bg').length) {
//
//       $('.edge-bg').each(function() {
//
//         if (window.innerWidth >= 768) {
//           $(this).removeClass('is-resized')
//           $(this).find('.edge-bg-back').css('position', 'absolute')
//           var h = $(this).find('.edge-bg-back-left, .edge-bg-back-right, .edge-bg-front-left, .edge-bg-front-right').map(function() {
//             return $(this).outerHeight()
//           }).get()
//           var mh = Math.max.apply(null, h)
//           $(this).css('height', mh);
//           $(this).addClass('is-resized')
//
//           $(this).find('.edge-bg-back .bg-image').css('height', mh)
//
//           var left
//
//           if ($(this).find('.edge-bg-front-left[class*="push"]').length) {
//             left = $(this).find('.edge-bg-front-right').offset().left + $(this).find('.edge-bg-front-right').outerWidth()
//           } else {
//             left = $(this).find('.edge-bg-front-left').offset().left + $(this).find('.edge-bg-front-left').outerWidth()
//           }
//           var right = $(window).width() - left
//
//           $(this).find('.edge-bg-back-left').width(left)
//           $(this).find('.edge-bg-back-right').width(right)
//
//         } else {
//
//           $(this).css('height', 'auto')
//           $(this).find('.edge-bg-back').css('position', 'relative')
//           $(this).find('.edge-bg-back-left').css({'width': '100%', 'height': 300})
//
//         }
//       })
//     }
//   })
// }

},{"../../../modules/modules":7,"../../../templates/templates":10}],2:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    var inputs = '.ginput_container input:not([type="submit"]):visible, .ginput_container textarea:visible';
    $(inputs).blur(function () {
      if ($(this).val() === '') {
        $(this).parents('.gfield').addClass('warning');
      } else {
        $(this).parents('.gfield').removeClass('warning');
      }
    });

    // disable submit button until inputs filled out
    $(inputs).on('keyup focus blur', function () {
      var empty = false;
      $(inputs).each(function () {
        if ($(this).val() === '') {
          empty = true;
        }
      });
      if (empty === true) {
        $('.gform_footer input[type="submit"]').attr('disabled', 'disabled');
      } else {
        $('.gform_footer input[type="submit"]').removeAttr('disabled');
      }
    });
  });
});

},{}],3:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-slider-equipment-slides').slick({
      slidesToShow: 2,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }]
    });
  });
});

},{}],4:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-slider-testimonials-slides').slick({
      responsive: [{
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: true
        }
      }]
    });
  });
});

},{}],5:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    resizeThumbnails();
  });
  $(window).resize(function () {
    resizeThumbnails();
  });
});

function resizeThumbnails() {
  jQuery(function ($) {
    $('.m-thumbnails').each(function () {
      if (window.innerWidth >= 768) {
        $(this).removeClass('is-resized');
        $(this).find('.m-thumbnails-column').css('height', 'auto');
        var h = $(this).find('[class*="col-"]').map(function () {
          return $(this).outerHeight();
        }).get();
        var mh = Math.max.apply(null, h);
        $(this).find('.m-thumbnails-column').css('height', mh);
        $(this).addClass('is-resized');
      } else {
        $(this).removeClass('is-resized');
        $(this).find('.m-thumbnails-column').css('height', 'auto');
      }
    });
  });
}

},{}],6:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    variableColumnsSlider();
  });
  $(window).resize(function () {
    variableColumnsSlider();
  });
});

function variableColumnsSlider() {
  jQuery(function ($) {
    if (window.innerWidth <= 767) {
      $('.m-variable-columns .row:not(.slick-initialized)').slick({
        arrows: false,
        dots: true,
        adaptiveHeight: true
      });
    } else {
      $('.m-variable-columns .row:not(.slick-initialized)').slick();
      $('.m-variable-columns .row').slick('unslick');
    }
  });
}

},{}],7:[function(require,module,exports){
'use strict';

require('./flex/form-full-width/module-form-full-width');

require('./flex/slider-equipment/module-slider-equipment');

require('./flex/slider-testimonials/module-slider-testimonials');

require('./flex/thumbnails/module-thumbnails');

require('./flex/variable-columns/module-variable-columns');

require('./sticky-ad/module-sticky-ad');

},{"./flex/form-full-width/module-form-full-width":2,"./flex/slider-equipment/module-slider-equipment":3,"./flex/slider-testimonials/module-slider-testimonials":4,"./flex/thumbnails/module-thumbnails":5,"./flex/variable-columns/module-variable-columns":6,"./sticky-ad/module-sticky-ad":8}],8:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-sticky-stuff-close').click(function (e) {
      e.preventDefault();
      var ad = $(this).parents('.m-sticky-stuff');
      if (ad.data('state') == 'is-up') {
        ad.velocity({
          translateY: ['100%', 0]
        }, {
          duration: 400,
          easing: 'easeInOut'
        });
        $(this).text('↑');
        ad.data('state', 'is-down');
      } else {
        ad.velocity({
          translateY: [0, '100%']
        }, {
          duration: 400,
          easing: 'easeInOut'
        });
        $(this).text('×');
        ad.data('state', 'is-up');
      }
    });
    var slider = $('.m-sticky-stuff-carousel');
    slider.on('init afterChange', function () {
      $('html').velocity('finish').velocity({
        paddingBottom: $('.m-sticky-stuff').outerHeight()
      }, {
        duration: 250
      });
    });
    slider.slick({
      autoplay: true,
      arrows: false,
      dots: false,
      autoplaySpeed: 8000,
      adaptiveHeight: true
    });
  });
});

},{}],9:[function(require,module,exports){
'use strict';

var accountType, numUsers, billingCycle, amount;

jQuery(function ($) {
  $(document).ready(function () {
    if (typeof StripeCheckout != 'undefined') {

      var form = $('.t-pro form'),
          handler = StripeCheckout.configure({
        key: 'pk_live_p3tAFaCk9F0N7gDAYlK84RoN',
        image: '/wp-content/themes/haulhound/assets/dist/images/HaulHound-Logo-square.jpg',
        locale: 'auto',
        token: function token(_token) {
          var data = new FormData(form[0]);
          data.append('amount', amount);
          data.append('token', JSON.stringify(_token));
          $('.loading-spinner').css('opacity', 0.8).show();
          $.ajax({
            url: '/wp-json/hh/v1/create-subscription',
            method: 'post',
            mimeType: 'multipart/form-data',
            data: data,
            processData: false,
            contentType: false,
            cache: false,
            success: function success(res) {
              res = JSON.parse(res);
              console.log(res.message);
              if (res.message == 'success') {
                window.location.href = '/pro/thank-you/';
              } else {
                window.location.href = '/pro/error/';
              }
            }
          });
        }
      });

      // Close Checkout on page navigation:
      window.addEventListener('popstate', function () {
        handler.close();
      });

      displayTotal(form, $);

      $('.t-pro [name="accountType"], .t-pro [name="numUsers"], .t-pro [name="billingCycle"]').change(function () {
        displayTotal(form, $);
      });

      form.submit(function (e) {
        e.preventDefault();
        accountType = form.find('[name="accountType"]:checked').val();
        numUsers = form.find('[name="numUsers"] :selected').val();
        billingCycle = form.find('[name="billingCycle"]:checked').val();
        amount = calculatePrice(accountType, numUsers, billingCycle);
        amount *= 100; // convert to cents
        var description = accountType + ' ' + billingCycle.toLowerCase() + ' plan (' + numUsers + ' users)';
        handler.open({
          name: 'HaulHound Pro free trial',
          description: description,
          zipCode: true,
          amount: amount,
          email: form.find('[name="email"]').val(),
          panelLabel: 'Pay {{amount}} in 7 days'
        });
      });
    }
  });
});

function calculatePrice(accountType, numUsers, billingCycle) {
  var amount;
  if (accountType == 'Carrier') {
    if (numUsers === '40+') {
      amount = 459;
    } else {
      amount = numUsers * 10 + 49;
    }
  } else if (accountType == 'Broker') {
    if (numUsers === '40+') {
      amount = 479;
    } else {
      amount = numUsers * 10 + 69;
    }
  }
  if (billingCycle == 'Biannual') {
    amount *= 5; // 1 free month
  } else if (billingCycle == 'Annual') {
    amount *= 9; // 3 free months
  }
  return amount;
}

function displayTotal(form, $) {
  accountType = form.find('[name="accountType"]:checked').val();
  numUsers = form.find('[name="numUsers"] :selected').val();
  billingCycle = form.find('[name="billingCycle"]:checked').val();
  amount = calculatePrice(accountType, numUsers, billingCycle);
  var monthlyAmount = calculatePrice(accountType, numUsers, 'Monthly'),
      biannualLabel = $('.t-pro-biannual-label'),
      annualLabel = $('.t-pro-annual-label'),
      total = $('.t-pro-total');

  biannualLabel.html('Biannual (every 6 months) - <strong>save $' + (1 / 6 * monthlyAmount).toFixed(2) + ' per month</strong>');
  annualLabel.html('Annual - <strong>save $' + (1 / 4 * monthlyAmount).toFixed(2) + ' per month</strong>');

  if (billingCycle == 'Monthly') {
    total.html('<span class="amount">$' + amount.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,') + '</span> per month');
  } else if (billingCycle == 'Biannual') {
    total.html('<span class="amount">$' + amount.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,') + '</span> every 6 months');
  } else if (billingCycle == 'Annual') {
    total.html('<span class="amount">$' + amount.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,') + '</span> per year');
  }
}

},{}],10:[function(require,module,exports){
'use strict';

require('./pro/template-pro');

},{"./pro/template-pro":9}]},{},[1]);
